export default __webpack_public_path__ + "static/media/dispose.ee50affb.jpg";